import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ecde490")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary RoleDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('role.roleSelection'),
    closable: false,
    modal: ""
  }, {
    footer: _withId(() => [
      (!_ctx.mandatory)
        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "p-button-text kn-button",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"])), [
            [_directive_t, 'common.close']
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: !_ctx.user.sessionRole,
        onClick: _ctx.changeRole
      }, null, 8, ["disabled", "onClick"]), [
        [_directive_t, 'common.save']
      ])
    ]),
    default: _withId(() => [
      (_ctx.mandatory)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "warn"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("role.mandatoryRoleWarning")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.user.sessionRole,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.sessionRole = $event)),
        class: "kn-material-input",
        options: _ctx.getRoleOptions(),
        placeholder: _ctx.$t('role.defaultRolePlaceholder')
      }, null, 8, ["modelValue", "options", "placeholder"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
})